import {connect} from 'react-redux';
import {SubGenresContainer} from './SubGenresContainer';
import {Genre} from '../../types';

export type State = {
    genres: {
        isLoading: boolean,
        genres: Genre[],
    }
};

export const mapState = (state: State) => {
    const {genres} = state;
    return genres;
};

export default connect(mapState)(SubGenresContainer);
